<template>
  <div class="scroll-births-and-hired">
    <div v-if="loading" class="d-flex justify-center align-center h-64">
      <vue-element-loading :active="loading" spinner="mini-spinner" color="#004250"/>
    </div>
    <transition name="fade">
      <div v-show="!loading">
          <div class="relative" v-for="(element, index) in birthdays" :key="index">
              <BirthdayCardText :element="element" />
            <hr>
          </div>
        <div v-if="!loading && !this.birthdays.length" class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 p-1 py-10 text-center">
          <div class="h-12 text-zt-dark-300 rowsDiv flex items-center justify-center font-normal">
            {{ $t('message.homeComponent.birthdays.no_events') }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import User from "../../apiClient/User";
import VueElementLoading from 'vue-element-loading';
import BirthdayCardText from './BirthdayCardText';

export default {

  components: {
    VueElementLoading,
    BirthdayCardText
  },

  props: {
    hasChanged: Number,
    filterSector: String
  },
  
  data() {
    return {
      loading:true,
      sectoresBirthday: null,
      birthdays: null,
      sectores:null
    };
  },

  async created() {
    console.log(this.filterSector);
    window.scrollTo(0, 0);
    this.user = new User();
    await this.getBirthdays();
    window.addEventListener("resize", this.detectResolution);
    this.detectResolution();
  },
  
  destroyed() {
    window.removeEventListener("resize", this.detectResolution);
  },

  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  methods: {
    detectResolution() {
      let resolution = window.screen.width;
      switch (true) {
        case (resolution < 500):
          this.numberShow = 6;
          break;
        case (resolution >= 501 && resolution <= 1023):
          this.numberShow = 9;
          break;
        case (resolution >= 1024 && resolution <= 1279):
          this.numberShow = 12;
          break;
        case (resolution >= 1280 && resolution <= 1439):
          this.numberShow = 14;
          break;
        case (resolution >= 1440 && resolution <= 1599):
          this.numberShow = 16;
          break;
        case (resolution >= 1600 && resolution <= 1919):
          this.numberShow = 21;
          break;
        case (resolution >= 1920 && resolution <= 2047):
          this.numberShow = 22;
          break;
        case (resolution >= 2048):
          this.numberShow = 23;
          break;
      }
    },
    getBirthdays() {
      this.user.getBirthdays()
        .then(response => {
          if (response.status === 200) {
            let res = response.data.results.data;
            this.sectoresBirthday = res;
            this.birthdays = res;
            var Sectores = []
            res.forEach(element => {
              element.cumplen.forEach(element => {
                Sectores.push(element.sector)
              });
            });
            this.sectores = [ ...new Set(Sectores) ];
            this.sectores.unshift('Ver todos');
            this.$store.dispatch('setHomeSectoresBirthdays', this.sectores);
            this.loading = false;
          }
        })
        .catch(error => {
            this.$swal({
              type: "error",
              title: 'Error',
              text: error,
              showConfirmButton: true,
              confirmButtonText: "Aceptar"
            });
        });
    },
    clearBirthdays(){
      this.loading = true;
    },
    filterBirthdayBySector(){
      if(this.filterSector !== 'Ver todos') {
        let filterBirthdays = this.sectoresBirthday
        .filter((b) => 
          b.cumplen.some((s) => s.sector.toLowerCase() === this.filterSector.toLowerCase()))
        .map(el => {
          return Object.assign({}, el, {cumplen : el.cumplen.filter(sb => sb.sector.toLowerCase() === this.filterSector.toLowerCase())});
        }); 
        this.birthdays = filterBirthdays;
      }else{
        this.birthdays = this.sectoresBirthday;
      }
      this.loading = false;
    }
  },

  watch: {
    hasChanged: function() {
      this.clearBirthdays();
      this.getBirthdays();
    },
    filterSector: async function() { 
      this.clearBirthdays();
      this.filterBirthdayBySector();
    }
	}
};
</script>

<style lang="scss" scoped>
@import "home.scss";
.day-title {
  min-width: 150px;
}
.birthday-container {
  max-width: 60px;
  font-size: $font-small;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
::v-deep .border-primary {
  border-color: $primary-color-200 !important;
}
::v-deep .text-zt-primary-200 {
    color: $primary-color-200 !important;
}
.rowsDiv {
  @media (min-width: 900px) {
    $line-height: 3;
    $font-size: 15px;
    $lines: 1;
    display: block;
    display: -webkit-box;
    height: $font-size * $line-height * $lines;
    font-size: $font-size;
    line-height: $line-height;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 900px) {
    align-items: center;
    $lines: 8;
    $font-size: 14px;
    $line-height: 1;
    display: block;
    display: -webkit-box;
    height: $font-size * $line-height * $lines;
    font-size: $font-size;
    line-height: $line-height;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.outline-unset {
  outline: unset;
}
</style>


